import api from './api';

export interface ServicePageContent {
  id: string;
  service_id: string;
  service_name: string;
  content_type: 'text' | 'image' | 'link' | 'qr_code' | 'pdf';
  content_data: {
    text?: string;
    image_url?: string;
    link_text?: string;
    link_url?: string;
    qr_label?: string;
    qr_data?: string;
    qr_mode?: 'generate' | 'upload';
    qr_image_url?: string;
    pdf_title?: string;
    pdf_url?: string;
    pdf_id?: string;
    pdf_file_name?: string;
    pdf_description?: string;
    pdf_cover_url?: string;
    original_name?: string;
  };
  order: number;
  created_at: string;
  updated_at: string;
}

export interface CreateServicePageContentRequest {
  service_id: string;
  content_type: 'text' | 'image' | 'link' | 'qr_code' | 'pdf';
  content_data: {
    text?: string;
    image_url?: string;
    link_text?: string;
    link_url?: string;
    qr_label?: string;
    qr_data?: string;
    qr_mode?: 'generate' | 'upload';
    qr_image_url?: string;
    pdf_title?: string;
    pdf_url?: string;
    pdf_id?: string;
    pdf_file_name?: string;
    pdf_description?: string;
    pdf_cover_url?: string;
    original_name?: string;
  };
  order: number;
}

export interface UpdateServicePageContentRequest {
  content_data: {
    text?: string;
    image_url?: string;
    link_text?: string;
    link_url?: string;
    qr_label?: string;
    qr_data?: string;
    qr_mode?: 'generate' | 'upload';
    qr_image_url?: string;
    pdf_title?: string;
    pdf_url?: string;
    pdf_id?: string;
    pdf_file_name?: string;
    pdf_description?: string;
    pdf_cover_url?: string;
    original_name?: string;
  };
  order?: number;
}

class ServicePageConfigApiService {
  async getServicePageContents(serviceId: string): Promise<ServicePageContent[]> {
    try {
      const response = await api.get(`/api/service-page-contents/${serviceId}/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contenus:', error);
      throw error;
    }
  }

  async getServicePageContentsPublic(serviceId: string): Promise<ServicePageContent[]> {
    try {
      const response = await api.get(`/api/services/${serviceId}/contents/`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contenus publics:', error);
      throw error;
    }
  }

  async createServicePageContent(data: CreateServicePageContentRequest): Promise<ServicePageContent> {
    try {
      const response = await api.post(`/api/service-page-contents/`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création du contenu:', error);
      throw error;
    }
  }

  async updateServicePageContent(contentId: string, data: UpdateServicePageContentRequest): Promise<ServicePageContent> {
    try {
      const response = await api.put(`/api/service-page-contents/${contentId}/update/`, data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour du contenu:', error);
      throw error;
    }
  }

  async deleteServicePageContent(contentId: string): Promise<void> {
    try {
      await api.delete(`/api/service-page-contents/${contentId}/delete/`);
    } catch (error) {
      console.error('Erreur lors de la suppression du contenu:', error);
      throw error;
    }
  }
}

export const servicePageConfigApiService = new ServicePageConfigApiService();
